import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h32v32H0z"
}), React.createElement("path", {
  d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm5.513 11.41c.002-7.213-11.03-7.213-11.028 0 0 1.46.32 2.031.32 2.031s-.821-.096-.821 1.27c0 2.412 1.253 2.348 1.253 3.047 0 1.732 1.754 3.031 1.754 3.046 0 4.679-4.318 3.681-6.606 5.372A13.952 13.952 0 0016 30c3.723 0 7.107-1.453 9.615-3.826-2.288-1.69-6.608-.691-6.608-5.37 0-.015 1.754-1.314 1.754-3.046 0-.7 1.253-.635 1.253-3.048 0-1.365-.752-1.269-.752-1.269s.25-.572.25-2.032z",
  fill: "#262626"
}));

var SvgMyAccountLarge = function SvgMyAccountLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgMyAccountLarge;